import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { DarkOne, lastOne, LightDark, Lightight, smallLighterText } from "../../Assets/CSS/Text";
import { Ctnbtn } from "../../Assets/CSS/Button";
import toast from "react-hot-toast";
import axios from "axios";

const SalaryStructure = ({ empData, setActiveTab, setSalaryCompleted }) => {
    const [loading, setLoading] = useState(false);
    const [salaryData, setSalaryData] = useState(null);
    const [ctcAmount, setCtcAmount] = useState("");
    // const [components, setComponents] = useState([]);
    const employeeId = empData.potentialEmployeeId;


    useEffect(() => {
        if (!employeeId) return;

        const fetchSalaryData = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/v1/potential-employees/${employeeId}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                setSalaryData(res.data);

                if (res.data?.ctcOfEmployee) {
                    setCtcAmount(res.data.ctcOfEmployee);
                    setSalaryCompleted(true);
                }
            }
            catch (err) {
                //     toast.error("Failed to load employee data");

                // ✅ NO SALARY YET → normal case
                if (err.response?.status === 404 || err.response?.status === 400) {
                    setSalaryData(null);   // allow CREATE
                    return;
                }

                // ❌ REAL error
                // toast.error("Failed to load employee data");
            }
            finally {
                setLoading(false);
            }
        };

        fetchSalaryData();
    }, [employeeId]);














    const handleSubmit = async () => {
        try {
            if (!ctcAmount || Number(ctcAmount) <= 0) {
                toast.error("Please enter CTC amount");
                return;
            }
            setLoading(true);
            const token = localStorage.getItem("token");


            const payload = {
                employeeId,
                ctcAmount: Number(ctcAmount), // ✅ ALREADY ANNUAL


            };

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/salary/assign`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            setSalaryCompleted(true);
            setActiveTab("letter");
            toast.success("Salary assigned successfully");

        } catch (error) {
            toast.error(error.response?.data?.message || "Submission failed");
        } finally {
            setLoading(false);
        }
    };



    const isSalaryAssigned = Boolean(
        salaryData?.ctcOfEmployee &&
        Object.keys(salaryData?.salaryComponents || {}).length > 0
    );

    return (
        <div className="container py-0" style={{ maxWidth: "900px" }}>
            <p style={Lightight}>Generate offer letter with salary structure and annexures</p>

            <h5 className="mb-4" style={lastOne}>Salary Breakdown</h5>



            <div className="row g-3">
                <div className="col-md-6 mb-4">

                    <label className="form-label d-flex justify-content-between">
                        <span style={LightDark}>CTC</span>
                        <small style={smallLighterText}>Annual</small>
                    </label>

                    <div className="d-flex gap-2">
                        <input
                            type="number"
                            className="form-control"
                            style={{
                                textAlign: "right",
                                borderRadius: "8px",
                                height: "52px",
                                fontWeight: "600",
                                backgroundColor: "#F9FAFB"
                            }}
                            value={ctcAmount}
                            onChange={(e) => setCtcAmount(e.target.value)}
                        />


                    </div>
                </div>
                <div>
                    <button
                        className=" px-4  continue-btn" style={Ctnbtn}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? "Loading..." : "Breakdown"}
                    </button>
                </div>


            </div>





        </div>
    );
};

export default SalaryStructure;

